<template>
  <div
    v-if="browseSignUpShow == true"
    id="BrowseSignUp"
    class="well"
    style="padding: 0 1em"
  >
    <b-tabs content-class="mt-3" justified v-if="inputData != null">
      <div
        class="dataTables_scrollBody"
        style="
          font-size: 20px;
          position: relative;
          overflow: auto;
          max-height: 800px;
          width: 100%;
          border-bottom: 1px solid #111;
          border-top: 1px solid #111;
        "
      >
        <b-table-simple
          class="ncut-table-menu-striped ncut-table-menu"
          fixed
          responsive
          bgcolor="#FFFFFF"
        >
          <b-thead class="ncut-thead-menu">
            <b-tr>
              <b-th style="min-width: 2em">序號</b-th>
              <b-th style="min-width: 12em">課程名稱</b-th>
              <b-th style="min-width: 5em">繳費截止時間</b-th>
              <b-th colspan="2" style="min-width: 30em">繳費帳號</b-th>
              <b-th style="min-width: 10em">總金額</b-th>
              <b-th style="min-width: 3em">繳費狀態</b-th>
              <b-th style="min-width: 3em">報名狀態</b-th>
              <b-th style="min-width: 3em">繳費單</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="(item, index) in filteredDocs"
              :key="item.signUpID"
              :index="item.signUpID"
              :cid="item.cID"
              v-bind:style="{
                background: selectedRowIndex == index ? headerColor : '',
              }"
              @click="selectedRowIndex = index"
            >
              <b-td style="text-align: right">
                {{ (currentPage - 1) * pageSize + index + 1 }}
              </b-td>
              <b-td style="text-align: left">
                <a href="#" @click.prevent="CourseDetail(item.cid)"
                  >{{ item.courseName }}
                </a>
              </b-td>
              <b-td style="text-align: left">{{ item.sdate }}</b-td>
              <b-td colspan="2" style="text-align: left">{{ item.account }}</b-td>
              <b-td style="text-align: right">{{ item.specialPrice }}</b-td>
              <b-td style="text-align: left">
                {{ item.isPayment == 0 ? "未繳款" : "已繳款" }}
              </b-td>
              <b-td style="text-align: left">
                {{ item.isComplete == 0 ? "待審核" : "審核通過" }}
              </b-td>
              <b-td style="text-align: left">
                <span v-if="item.isPayment == 0">
                  <i class="fas fa-download"></i>
                  <a
                    :href="
                      './WebApi/ociaRep/GetBillFormPDF/' +
                      item.signUpID +
                      '/' +
                      item.account
                    "
                  >
                    下載
                  </a>
                </span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-pagination
          v-model="currentPage"
          :total-rows="total"
          :per-page="pageSize"
          v-if="total > pageSize"
        />
      </div>
    </b-tabs>
  </div>

  <div v-else if="detailShow">
    <table
      style="text-align: left; font-size: 20px"
      class="table"
      v-if="null != inputData"
    >
      <thead>
        <tr>
          <th>
            <h1 style="font-weight: bold">
              {{ inputData[0].courseName }}
            </h1>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div>
              <span style="font-weight: bold">屬性類別：</span
              ><span>{{ inputData[0].courseClass }}</span>
            </div>
          </td>
        </tr>
        <tr class="table-success">
          <td>
            <div>
              <span style="font-weight: bold">開課日期：</span
              ><span>{{ inputData[0].sdate }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <span style="font-weight: bold">課程名稱：</span
              ><span>{{ inputData[0].courseName }}</span>
            </div>
          </td>
        </tr>
        <tr class="table-success">
          <td>
            <div>
              <span style="font-weight: bold">起訖日期：</span
              ><span
                >{{ inputData[0].sdate }}&nbsp;~&nbsp;{{
                  inputData[0].edate
                }}</span
              >
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <span style="font-weight: bold">上課時間：</span
              ><span
                >星期{{ inputData[0].week }}&nbsp;{{
                  inputData[0].stime
                }}&nbsp;~&nbsp;{{ inputData[0].etime }}</span
              >
            </div>
          </td>
        </tr>
        <tr class="table-success">
          <td>
            <div>
              <span style="font-weight: bold">課程簡介：</span
              ><span>{{ inputData[0].courseIntroduce }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <span style="font-weight: bold">課程費用：</span
              ><span>{{ inputData[0].courseCost }}</span>
            </div>
          </td>
        </tr>
        <tr class="table-success">
          <td>
            <div>
              <span style="font-weight: bold">地點：</span
              ><span>{{ inputData[0].courseAddr }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <span style="font-weight: bold">聯絡專線：</span
              ><span>{{ inputData[0].courseTel }}</span>
            </div>
          </td>
        </tr>
        <tr class="table-success">
          <td>
            <div>
              <span style="font-weight: bold">Email：</span
              ><span>{{ inputData[0].email }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <span style="font-weight: bold">上課老師：</span
              ><span>{{ inputData[0].teacherName }}教授</span>
            </div>
          </td>
        </tr>
        <tr class="table-success">
          <td>
            <div>
              <span style="font-weight: bold">詳細網址：</span
              ><span
                ><a :href="inputData[0].link">{{ inputData[0].link }}</a></span
              >
            </div>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <div>
              <span style="font-weight: bold"
                ><a href="#" @click.prevent="getAll()">回上一頁</a></span
              ><span></span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-model="currentPage"
      :total-rows="total"
      :per-page="pageSize"
      v-if="total > pageSize"
    />
  </div>
</template>

<script>
import * as tools from '../tool'
export default {
  name: 'BrowseSignUp',
  props: ['StdID'],
  data () {
    return {
      browseSignUpShow: true,
      detailShow: false,
      total: 0,
      isIE: false,
      inputData: null,
      selectedRowIndex: 0,
      currentPage: 1,
      cid: '',
      pageSize: 10,
      queryInfo: {
        sysId: 0
      }
    }
  },
  computed: {
    filteredDocs: function () {
      let data = []
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    }
  },
  methods: {
    printPayBill () {},
    CourseDetail (Cid) {
      const vm = this

      this.$http
        .get('../WebApi/ociaRep/GetociaCourseDetail/'.concat(Cid))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data
          }
        })
        .catch(function (error) {
          alert('網路連線失敗' + error)
        })
      this.browseSignUpShow = false
      this.detailShow = true
    },
    getAll () {
      const vm = this

      this.$http
        .get('./WebApi/ociaRep/GetociaSignUp/'.concat(vm.$props.StdID))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data
            vm.total = vm.inputData.length
            //  console.log(vm.inputData);
          }
        })
        .catch(function (error) {
          alert('網路連線失敗' + error)
        })
      this.browseSignUpShow = true
      this.detailShow = false
    }
  },

  created () {
    console.log('======created browseSignUpView =====')
    this.isIE =
      navigator.userAgent.indexOf('MSIE ') > -1 ||
      navigator.userAgent.indexOf('Trident/') > -1 ||
      navigator.userAgent.indexOf('Edge') > -1
    const vm = this
    vm.getAll()
    // let vm = this;

    // this.$http
    //   .get("./WebApi/ociaRep/GetociaSignUp/".concat(vm.$props.StdID))
    //   .then((response) => {
    //     if (!tools.isNull(response)) {
    //       vm.inputData = response.data;
    //       console.log(vm.inputData);
    //     }
    //   })
    //   .catch(function (error) {
    //     tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
    //   });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
